export enum Languages {
    cs = "cs",
    en = "en",
}

export const DEFAULT_LANGUAGE = Languages.en as const;
export const EMPTY_VALUE_PLACEHOLDER = "" as const;
